/* eslint-disable */
/* jshint ignore:start */
import jQuery from "jquery";

jQuery(function ($) {
  var isDesktopScreen = windowSize() > 1023, //used on "scroll", we need a variable as windowSize() removes the scrollbar!
    transitionSpeed = 300,
    isMenuAimActive = false; //prevent reattaching menuAim handlers (i.e. $(document).mousemove()) over and over on setupNav()

  const primaryNavigationClass = "primary-navigation";
  const panelClass = "primary-navigation__sub-list-panel";
  const panelShownClass = "primary-navigation__sub-list-panel--shown";
  const toggleDownClass = "primary-navigation__list-item--toggled-down";
  const toggleDownDesktopClass =
    "primary-navigation__sub-list-item--toggled-desktop";
  const btnMobileNav = $(".js-header-mobile-nav");
  const btnSearch = $(".js-search-toggle");
  const btnSearchClass = "js-search-toggle";
  const btnLogin = $(".js-login-toggle");

  function windowSize() {
    $("body, html").addClass("no-scroll"); //set class to hide scrollbars to measure the width
    var windowWidth = $(window).width();
    $(".no-scroll").removeClass("no-scroll"); //reset class
    if ($(".primary-navigation--visible").length) {
      $("body, html").addClass("no-scroll"); //set class to hide scrollbars to measure the width
    }
    return windowWidth;
  }
  function isDesktopSize() {
    isDesktopScreen = windowSize() > 1023;
    return isDesktopScreen;
  }
  function isTopNavHidden() {
    var navBar = document.querySelector(".primary-header");
    return navBar.classList.contains("primary-header--with-top-nav-hidden");
  }
  function setNavHeight() {
    var $level1Li = $(
      ".primary-navigation__list-item.primary-navigation__list-item--toggled-down"
    );
    var $level1Panel = $level1Li.find(".primary-navigation__sub-list-panel");
    var $level2Ul = $level1Li.find(".primary-navigation__sub-list-level-2");
    var $level2Wrapper = $level1Li.find(
      ".primary-navigation__sub-list-wrapper--constrain"
    );
    // var $level2Wrapper = $level1Li.find('.primary-navigation__sub-list-wrapper');
    var $level3Ul = $level2Ul.find(
      ".primary-navigation__sub-list-item-level-2.primary-navigation__sub-list-item--toggled-desktop > .primary-navigation__sub-list"
    );
    var $level4Ul = $level3Ul.find(
      ".primary-navigation__sub-list-item-level-3.primary-navigation__sub-list-item--toggled-desktop > .primary-navigation__sub-list"
    );
    var height = Math.max(
      $level1Panel.outerHeight() || 0,
      $level2Ul.outerHeight() || 0,
      $level3Ul.outerHeight() || 0,
      $level4Ul.outerHeight() || 0
    );
    $level2Wrapper.css({ "min-height": height + "px" });
  }

  var $primaryNavigation = $(".primary-navigation");
  var $primaryNavList = $(".primary-navigation__list");
  function shiftToLevel(level) {
    $primaryNavList.removeClass("primary-navigation__list--level-1");
    $primaryNavList.removeClass("primary-navigation__list--level-2");
    $primaryNavList.removeClass("primary-navigation__list--level-3");
    $primaryNavList.removeClass("primary-navigation__list--level-4");
    $primaryNavList.addClass("primary-navigation__list--level-" + level);
  }
  function closeNav() {
    if ($primaryNavigation?.length) {
      $(".primary-navigation__list-item--toggled-down").removeClass(
        "primary-navigation__list-item--toggled-down"
      );
      $(".primary-navigation__sub-list-panel--shown").removeClass(
        "primary-navigation__sub-list-panel--shown"
      );
      $(".primary-navigation__sub-list-item--toggled-desktop").removeClass(
        "primary-navigation__sub-list-item--toggled-desktop"
      );
      $(".primary-navigation__sub-list-wrapper--constrain").css({
        minHeight: 0,
      });
      const nav = document.querySelector("." + primaryNavigationClass);
      const node = nav.querySelectorAll("[aria-expanded=true]");

      for (let i = 0; i < node.length; i++) {
        setExpanded(node[i], false);
      }
    }
  }
  function closeSearch() {
    $(".primary-header__search-container").removeClass(
      "primary-header__search-container--shown"
    );
    $(".js-search-toggle").removeClass("toggled");
  }
  function closeLogin() {
    $(".js-login-toggle").removeClass("toggled");
    $("body").removeClass("login-areas-visible");
  }
  function setupNoScrollForNav() {
    if ($primaryNavigation.hasClass("primary-navigation--visible")) {
      /*$('html,body').animate({
                scrollTop: 0
            }, transitionSpeed);*/
      $("html, body").addClass("no-scroll");
    } else {
      $("html, body").removeClass("no-scroll");
    }
  }

  const setExpanded = (item, value) => {
    item?.setAttribute("aria-expanded", value);
    const isOpen = value === "true" || value === true;
    const expandText = item?.querySelector(".primary-navigation__expand-text");
    if (expandText) {
      expandText.textContent = isOpen ? "Close" : "Expand";
    }
  };

  // Submenu methods
  function openFirstLevel(e) {
    e.preventDefault();
    closeSearch();
    closeLogin();
    const parentEl = e.target.parentElement;
    const isOpenEl = parentEl.classList.contains(toggleDownClass);
    const toggleDownEl = document.querySelector("." + toggleDownClass);
    const toggleDownElDesktop = document.querySelector(
      "." + toggleDownDesktopClass
    );

    setExpanded(e.target, !isOpenEl);

    // Reset aria-expanded on previous trigger when switching items
    if (toggleDownEl) {
      var prevTrigger = toggleDownEl.querySelector(
        ".primary-navigation__list-item-link"
      );
      setExpanded(prevTrigger, false);
    }
    toggleDownEl?.classList.remove(toggleDownClass);
    toggleDownElDesktop?.classList.remove(toggleDownDesktopClass);

    if (!isOpenEl) {
      parentEl.classList.add(toggleDownClass);
    }

    const panel = parentEl.querySelector("." + panelClass);
    if (panel) {
      let panelShown = panel.classList.contains(panelShownClass);
      if (!panelShown) {
        setTimeout(() => {
          panel.classList.add(panelShownClass);
        });
      } else {
        document
          .querySelector("." + panelShownClass)
          .classList.remove(panelShownClass);
      }
    } else {
      const panelClosed = document.querySelector("." + panelShownClass);
      panelClosed?.classList?.remove(panelShownClass);
    }
    setNavHeight();
  }

  function setupNav() {
    windowSize();
    if (isDesktopSize()) {
      setNavHeight();
      shiftToLevel(1);
      $(
        ".primary-navigation__list-item--has-children > .primary-navigation__list-item-link"
      ).off("click");
      $(".primary-navigation__sub-list-item-link--back").off("click");
      $(
        ".primary-navigation__sub-list-item--has-children > .primary-navigation__sub-list-item-link"
      ).off("click");
      $(".primary-navigation__list-item--toggled").removeClass(
        "primary-navigation__list-item--toggled"
      );
      $(".primary-navigation__sub-list-item--toggled").removeClass(
        "primary-navigation__sub-list-item--toggled"
      );

      $(
        ".primary-navigation__list-item--has-children .primary-navigation__list-item-link"
      ).click(function (e) {
        openFirstLevel(e);
      });

      // Accessible button toggle for keyboard users
      $(".primary-navigation__sub-list-item-link--accessible").click(function (e) {
        e.preventDefault();
        var $btn = $(this);
        var $li = $btn.parent();
        var isExpanded = $btn.attr("aria-expanded") === "true";

        if (isExpanded) {
          $li.removeClass(toggleDownDesktopClass);
          setExpanded(this, "false");
        } else {
          // Close any previously toggled sibling
          $li.siblings("." + toggleDownDesktopClass).each(function () {
            $(this).removeClass(toggleDownDesktopClass);
            var prevBtn = this.querySelector(".primary-navigation__sub-list-item-link--accessible");
            if (prevBtn) setExpanded(prevBtn, "false");
          });
          $li.addClass(toggleDownDesktopClass);
          setExpanded(this, "true");
        }
        setNavHeight();
      });

      if (!isMenuAimActive) {
        isMenuAimActive = true; //prevent reattaching menuAim handlers over and over on setupNav()
        //Subnav intent - Level 2
        //Clear subnav after enough mouseExit time
        $(".primary-navigation__sub-list-level-2").menuAim({
          activate: function (row) {
            var $level2Li = $(row);
            var $level2A = $level2Li
              .children("a.primary-navigation__sub-list-item-link")
              .first();
            $level2Li.addClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            setExpanded($level2A[0], "true");
            setNavHeight();
          },
          deactivate: function (row) {
            var $level2Li = $(row);
            var $level2A = $level2Li
              .children("a.primary-navigation__sub-list-item-link")
              .first();
            $level2Li.removeClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            setExpanded($level2A[0], "false");
            setNavHeight();
          },
          exitMenu: function (row) {
            return true;
          },
          rowSelector: "> li",
          submenuSelector: "a.primary-navigation__sub-list-item--has-children",
          submenuDirection: "right",
        });
        // level 3
        $(".primary-navigation__sub-list-level-3").menuAim({
          activate: function (row) {
            var $level3Li = $(row);
            var $level3A = $level3Li
              .children("a.primary-navigation__sub-list-item-link")
              .first();
            setExpanded($level3A[0], "true");
            $level3Li.addClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            setNavHeight();
          },
          deactivate: function (row) {
            var $level3Li = $(row);
            var $level3A = $level3Li
              .children("a.primary-navigation__sub-list-item-link")
              .first();
            setExpanded($level3A[0], "false");
            $level3Li.removeClass(
              "primary-navigation__sub-list-item--toggled-desktop"
            );
            setNavHeight();
          },
          rowSelector: "> li",
          exitMenu: function (row) {
            return true;
          },
          submenuSelector: ".primary-navigation__sub-list-item--has-children",
          submenuDirection: "right",
        });
      }
    } else {
      setupNoScrollForNav();
      shiftToLevel(1);
      $(
        ".primary-navigation__list-item--has-children .primary-navigation__list-item-link"
      ).off("click");
      $(
        ".primary-navigation__list-item--has-children > .primary-navigation__list-item-link"
      ).click(function (e) {
        e.preventDefault();
        var $li = $(this).parent();
        $li.addClass("primary-navigation__list-item--toggled");
        shiftToLevel(2);
      });
      $(".primary-navigation__sub-list-item-link--back").click(function (e) {
        e.preventDefault();
        var link = this;
        var level = $(link)
          .closest(".primary-navigation__sub-list")
          .data("level");
        shiftToLevel(level - 1);
        setTimeout(function () {
          var $sublistItemToggled = $(link).closest(
            ".primary-navigation__sub-list-item--toggled"
          );
          if ($sublistItemToggled.length) {
            $sublistItemToggled.removeClass(
              "primary-navigation__sub-list-item--toggled"
            );
          } else {
            $(link)
              .closest(".primary-navigation__list-item--toggled")
              .removeClass("primary-navigation__list-item--toggled");
          }
        }, transitionSpeed);
      });
      $(
        ".primary-navigation__sub-list-item--has-children > .primary-navigation__sub-list-item-link"
      ).click(function (e) {
        e.preventDefault();
        var level = $(this)
          .closest(".primary-navigation__sub-list")
          .data("level");
        var $li = $(this).parent();
        $li.addClass("primary-navigation__sub-list-item--toggled");
        shiftToLevel(level + 1);
      });
    }
  }

  var debounceSetupNav = $.debounce(setupNav, 300);
  var debounceSetupStickyNav = $.debounce(setupStickyNav, 300);

  debounceSetupNav();
  debounceSetupStickyNav();

  $(window).on("load resize orientationchange", function () {
    debounceSetupNav();
    debounceSetupStickyNav();
    if (!$(".primary-navigation--always-thin").length) {
      debounceSetupStickyNav();
    }
  });


  $(document).on("click touchend", function (e) {
    if (
      $(e.target).closest("nav").length !== 0 ||
      $(e.target).closest(".js-search-toggle").length !== 0 ||
      $(e.target).hasClass("primary-navigation__sub-list") ||
      $(e.target).hasClass("primary-navigation__list") ||
      $(e.target).closest("primary-navigation__sub-list").length !== 0 ||
      $(e.target).closest("primary-navigation__list").length !== 0 ||
      $(e.target).hasClass("searchform") ||
      $(e.target).closest(".searchform").length !== 0 ||
      $(e.target).closest(".primary-navigation__search").length !== 0 ||
      $(e.target).hasClass("js-login-toggle") ||
      $(e.target).closest(".js-login-toggle").length !== 0 ||
      $(e.target).hasClass("login-areas__list-item-link") ||
      $(e.target).closest(".login-areas__list-item-link").length !== 0
    ) {
      //console.log('Do not close');
    } else {
      closeNav();
      closeSearch();
      closeLogin();
    }
  });

  // Close open nav/search/login on Escape and return focus to trigger
  $(document).on("keydown", function (e) {
    if (e.key === "Escape") {
      var $openItem = $("." + toggleDownClass);
      var hadOpenNav = $openItem.length > 0;
      var hadOpenMobileNav =
        $primaryNavigation.hasClass("primary-navigation--visible");
      var hadOpenSearch =
        $(".primary-header__search-container--shown").length > 0;
      var hadOpenLogin = $("body").hasClass("login-areas-visible");

      if (hadOpenNav) {
        var $trigger = $openItem
          .find(".primary-navigation__list-item-link")
          .first();
        closeNav();
        $trigger.trigger("focus");
      } else if (hadOpenMobileNav) {
        setMobileNavigation();
        btnMobileNav.trigger("focus");
      } else if (hadOpenSearch) {
        closeSearch();
        btnSearch.first().trigger("focus");
      } else if (hadOpenLogin) {
        closeLogin();
        btnLogin.first().trigger("focus");
      }
    }
  });

  $("nav").on("touchmove", function (e) {
    e.stopPropagation(); //seems fine without it?
  });

  //Mobile menu
  const toggleNavElement = (
    e,
    isCloseLogin,
    isCloseSearch,
    container,
    containerClass
  ) => {
    e.preventDefault();
    closeNav();
    if (isCloseLogin) {
      closeLogin();
    }
    if (isCloseSearch) {
      closeSearch();
    }
    if (container.length) {
      $(container).toggleClass(containerClass);
    }
  };

  const setMobileNavigation = () => {
    if (
      $(".js-header-mobile-nav i").hasClass(
        "primary-header__mobile-nav-icon-bars"
      )
    ) {
      $(".js-header-mobile-nav i")
        .removeClass("primary-header__mobile-nav-icon-bars")
        .addClass("primary-header__mobile-nav-icon-times");
      $("body, html").addClass("no-scroll"); //set class to hide scrollbars to measure the width
    } else {
      $(".no-scroll").removeClass("no-scroll"); //reset class
      $(".js-header-mobile-nav i")
        .addClass("primary-header__mobile-nav-icon-bars")
        .removeClass("primary-header__mobile-nav-icon-times");
    }
    if ($primaryNavigation.hasClass("primary-navigation--visible")) {
      $primaryNavigation.removeClass("primary-navigation--visible");
    } else {
      $primaryNavigation.addClass("primary-navigation--visible");
    }
    setupNoScrollForNav();
  };

  const setMobileSearch = (e) => {
    toggleNavElement(e, true, false, btnSearchClass, "toggled");
    $(".primary-header__search-container").toggleClass(
      "primary-header__search-container--shown"
    );
    if ($(".primary-header__search-container--shown").length) {
      $(".primary-navigation__search-input").trigger("focus");
    }
  };

  if (btnMobileNav.length) {
    btnMobileNav.on("keydown", function (e) {
      if (e.which == 13) {
        setMobileNavigation();
      }
    });
    btnMobileNav.on("click", function () {
      setMobileNavigation();
    });
  }

  if (btnSearch.length) {
    btnSearch.on("keydown", function (e) {
      if (e.which == 13) {
        setMobileSearch(e);
      }
    });
    btnSearch.on("click", function (e) {
      setMobileSearch(e);
    });
  }

  if (btnLogin.length) {
    btnLogin.on("keydown", function (e) {
      if (e.which == 13) {
        toggleNavElement(e, false, true, "body", "login-areas-visible");
      }
    });
    btnLogin.on("click", function (e) {
      toggleNavElement(e, false, true, "body", "login-areas-visible");
    });
  }

  debounceSetupNav();
  debounceSetupStickyNav();

  // Sticky header
  function setupStickyNav() {
    isDesktopSize();
    stickyNav();
  }
  function stickyNav() {
    var $navContainer = $(".primary-navigation");

    if ($navContainer.length) {
      var $headerContainer = $(".primary-header");
      var $searchContainer = $(".primary-header__search-container");
      var scrollOffset = $(window).scrollTop();
      if (isDesktopScreen) {
        $(".no-scroll").removeClass("no-scroll"); //reset class
        //if (scrollOffset > $headerContainer.outerHeight()) {
        if (scrollOffset > 120) {
          $headerContainer.addClass("primary-header--fixed");
          $navContainer.addClass("primary-navigation--fixed");
          if (isTopNavHidden()) {
            $searchContainer.addClass(
              "primary-header__search-container--with-top-nav-hidden-and-thin-nav"
            );
            $searchContainer.removeClass(
              "primary-header__search-container--with-top-nav-hidden"
            );
          } else {
            $searchContainer.addClass(
              "primary-header__search-container--fixed"
            );
          }
        } else {
          $headerContainer.removeClass("primary-header--fixed");
          $navContainer.removeClass("primary-navigation--fixed");
          if (isTopNavHidden()) {
            $searchContainer.addClass(
              "primary-header__search-container--with-top-nav-hidden"
            );
            $searchContainer.removeClass(
              "primary-header__search-container--with-top-nav-hidden-and-thin-nav"
            );
          } else {
            $searchContainer.removeClass(
              "primary-header__search-container--fixed"
            );
          }
        }
      } else {
        if (scrollOffset > 0) {
          $headerContainer.addClass("primary-header--fixed");
          $navContainer.addClass("primary-navigation--fixed");
          $searchContainer.addClass("primary-header__search-container--fixed");
        } else {
          $headerContainer.removeClass("primary-header--fixed");
          $navContainer.removeClass("primary-navigation--fixed");
          $searchContainer.removeClass(
            "primary-header__search-container--fixed"
          );
        }
      }
    }
  }

  if (!$(".primary-navigation--always-thin").length) {
    $(window).scroll(stickyNav);
  } else {
    $(".main-area").addClass("main-area--with-nav-fixed-thin");
  }
}); //jQuery
/* jshint ignore:end */
